import { useMemo } from 'react';
import { useSales } from '../../../api/hooks/sales/useSales';
import { EntityPaginationData } from '../../../components/molecules/EntityPaginationData';
import { SORT_BY_SALES, SORT_DIRECTION } from '../../../interfaces/enumerables';
import { getSalesSortByFilter } from '../../../services/utils/sortData';
import { SalesItemCard } from '../../Sales/components/SalesItemCard';

const makeUseSalesForCustomer = (customerId: string) =>
  // eslint-disable-next-line react-hooks/rules-of-hooks
  function useSalesForCustomer(
    page: number,
    sortByValue: any,
    sortDirection: SORT_DIRECTION,
    search: string,
    type?: any,
  ) {
    return useSales(page, sortByValue, sortDirection, search, type, customerId);
  };

interface Props {
  customerId: string;
}

export const CustomerInvoices = ({ customerId }: Props) => {
  const salesSortByFilter = useMemo(() => getSalesSortByFilter(), []);
  const useSalesForCustomer = useMemo(() => makeUseSalesForCustomer(customerId), [customerId]);

  return (
    <EntityPaginationData
      useDataHook={useSalesForCustomer}
      ItemCardData={SalesItemCard}
      sortByFilter={salesSortByFilter}
      hideCreateButton
      hideSearchButton
      hideFiltersSection
      sortByDefaultKey={SORT_BY_SALES.SENT_TO_AADE_AT}
      sortDirectionValue={SORT_DIRECTION.DESC}
      headerClass="entity-pagination-wrapper-embedded entity-pagination-wrapper-12-h-padding"
      noDataMsg="CUSTOMERS.NO_INVOICES"
    />
  );
};
